import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class NoOriginal extends React.PureComponent {
    static propTypes = { content: PropTypes.array };

    render() {
        const { content } = this.props;

        // 暂时还没有参考的数据，问过王禹
        return (
            <div className={styles.origin_wrap}>
                <div className={styles.no_data} />
            </div>
        );
    }
}

export default NoOriginal;
